import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const CATEGORY_LABELS = {
  'legal': '法律合规', 'finance': '财务审计', 'business': '商务拓展',
  'engineering': '工程技术', 'hr': '人力资源', 'supply-chain': '供应链', 'other': '其他',
};
const CATEGORY_ICONS = {
  'legal': '⚖️', 'finance': '💰', 'business': '🌐',
  'engineering': '🏗️', 'hr': '📋', 'supply-chain': '📦', 'other': '📄',
};

function StarRating({ rating }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.3;
  return (
    <span style={{ color: '#f59e0b', fontSize: '0.95rem', letterSpacing: 1 }}>
      {'★'.repeat(full)}{half ? '½' : ''}{'☆'.repeat(5 - full - (half ? 1 : 0))}
      <span style={{ color: 'var(--text-light)', fontSize: '0.82rem', marginLeft: 4 }}>
        {Number(rating).toFixed(1)}
      </span>
    </span>
  );
}

function Experts() {
  const [experts, setExperts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState('');

  useEffect(() => {
    setLoading(true);
    const params = category ? `?category=${category}` : '';
    api.get(`/experts${params}`)
      .then(res => setExperts(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="container" style={{ paddingTop: 20, paddingBottom: 60 }}>
      <div className="page-header" style={{ textAlign: 'center', marginBottom: 32 }}>
        <h1 className="page-title">职业规划咨询</h1>
        <p className="page-subtitle">连接行业专家，为你的涉外职业发展提供专业指导</p>
      </div>

      {/* 分类筛选 */}
      <div className="filter-bar" style={{ marginBottom: 24 }}>
        {[{ value: '', label: '全部' }, ...Object.entries(CATEGORY_LABELS).map(([v, l]) => ({ value: v, label: l }))].map(c => (
          <button
            key={c.value}
            className={`btn btn-sm ${category === c.value ? 'btn-primary' : 'btn-ghost'}`}
            onClick={() => setCategory(c.value)}
            style={{ fontSize: '0.85rem' }}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="loading">加载中...</div>
      ) : experts.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">🎓</div>
          <p className="empty-state-text">该类别暂无咨询专家</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 20 }}>
          {experts.map(expert => (
            <Link key={expert.id} to={`/experts/${expert.id}`} style={{ textDecoration: 'none' }}>
              <div className="card card-clickable" style={{ padding: 24, height: '100%' }}>
                <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                  <div style={{
                    width: 56, height: 56, borderRadius: '50%',
                    background: 'var(--primary-light)', color: 'var(--primary)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '1.5rem', flexShrink: 0,
                  }}>
                    {CATEGORY_ICONS[expert.category] || '🎓'}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text)' }}>
                        {expert.displayName}
                      </span>
                      <span className="tag tag-purple" style={{ fontSize: '0.75rem' }}>
                        {CATEGORY_LABELS[expert.category] || expert.category}
                      </span>
                    </div>
                    {expert.title && (
                      <div style={{ fontSize: '0.88rem', color: 'var(--text-secondary)', marginTop: 4 }}>
                        {expert.title}
                      </div>
                    )}
                    {expert.experience && (
                      <div style={{ fontSize: '0.82rem', color: 'var(--text-light)', marginTop: 4 }}>
                        {expert.experience}
                      </div>
                    )}
                    {expert.credentials && (
                      <div style={{ fontSize: '0.82rem', color: 'var(--primary)', marginTop: 4 }}>
                        🏅 {expert.credentials}
                      </div>
                    )}
                    <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 12 }}>
                      <StarRating rating={expert.avgRating || 0} />
                      <span style={{ fontSize: '0.8rem', color: 'var(--text-light)' }}>
                        {expert.reviewCount || 0} 条评价
                      </span>
                    </div>
                  </div>
                </div>
                {expert.specialties && (
                  <div style={{ marginTop: 12, fontSize: '0.82rem', color: 'var(--text-secondary)' }}>
                    <strong>擅长领域：</strong>{expert.specialties}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default Experts;
